module.exports = __webpack_public_path__ + "img/0x8f552a71EFE5eeFc207Bf75485b356A0b3f01eC9.960dfd0d.png";